import {
  RARE,
  AVAILABLE,
  COMMON,
  UNCOMMON,
  SPECIAL,
  LEGENDARY,
  MYTHICAL,
  LOCKED,
  PROCESSING,
  Decp_Key_dev_2,
  Decp_Key_Prod_2,
} from "../constants/colors";
import {
  decKeyDev1,
  decKeyProd1,
  PLOT_STATUS,
  pubKeyDev1,
  pubKeyProd1,
} from "../constants/config";
import $ from "jquery";
import { collection, getDocs, query } from "firebase/firestore";
import { firestoreInstance } from "../utilities/firebase";

import { JSEncrypt } from "jsencrypt";
import _ from "lodash";
export default class HELPER {
  static getColorByStatus = (plot) => {
    let color = AVAILABLE;
    if (plot) {
      if (plot.status.toUpperCase() === PLOT_STATUS.AVAILABLE) {
        color = AVAILABLE;
      } else if (plot.status.toUpperCase() === PLOT_STATUS.LOCKED) {
        color = LOCKED;
      } else if (plot.status.toUpperCase() === PLOT_STATUS.PROCESSING) {
        color = PROCESSING;
      } else if (plot.status.toUpperCase() === "SOLD") {
        if (plot.rarity?.toUpperCase() === "RARE") color = RARE;
        else if (plot.rarity?.toUpperCase() === "COMMON") color = COMMON;
        else if (plot.rarity?.toUpperCase() === "UNCOMMON") color = UNCOMMON;
        else if (plot.rarity?.toUpperCase() === "SPECIAL") color = SPECIAL;
        else if (plot.rarity?.toUpperCase() === "LEGENDARY") color = LEGENDARY;
        else if (plot.rarity?.toUpperCase() === "MYTHICAL") color = MYTHICAL;
      }
    }

    return color;
  };
}
let a = "U5YozmNXgicLl";
const getProdEndKey = () => {
  return ["U", "j", "i", "4", "v", "6"].join("");
};
export const getJSEncriptSignedData = (key, data) => {
  try {
    var encrypt = new JSEncrypt();

    encrypt.setPublicKey(key);

    return encrypt.encrypt(data);
  } catch (error) {
    console.log("getJSEncriptSignedData==>", error);
    return null;
  }
};

export const getTruncatedAddress = (str) => {
  if (str && str != null) {
    return str?.slice(0, 4) + str?.slice(-8).replace(/.(?=...)/g, "*");
  }
  return null;
};

export const getPubKeyForEnvSig = (env) => {
  if (env == ["D", "O", "R", "P"].reverse().join("")) {
    return pubKeyProd1;
  } else {
    return pubKeyDev1;
  }
};

export const getDecriptionForEnvSig = (env) => {
  if (env == ["D", "O", "R", "P"].reverse().join("")) {
    return (
      decKeyProd1 +
      "XQr1DqoS8n1NYI1wLLTq1HQi+" +
      Decp_Key_Prod_2 +
      getProdEndKey()
    );
  } else {
    return decKeyDev1 + a + Decp_Key_dev_2 + ["W", "e", "a", "0", "="].join("");
  }
};
// Get timeslot from firebase for buy process
export const getEthTimeSlots = async () => {
  const q = query(
    collection(
      firestoreInstance,
      "/virtua_prime/virtua_island/zones/monster/slots"
    )
  );
  return await getDocs(q);
};

// Get cardano time slots from firebase for buy process
export const getCardanoTimeSlots = async () => {
  const q = query(
    collection(
      firestoreInstance,
      "/virtua_prime/virtua_island/zones/monster/cardano_slots"
    )
  );
  return await getDocs(q);
};

export function zeroPad(num, places) {
  var zero = places - num.toString().length + 1;
  return Array(+(zero > 0 && zero)).join("0") + num;
}

let curTime = +new Date().getTime();

export async function runCardanoTimer(timerCallback) {
  $("body").removeClass("deedTime");
  await getCardanoTimeSlots()
    .then((querySnapshot) => {
      let mySlots = [];

      querySnapshot?.forEach((doc) => {
        mySlots.push(doc.data());
      });
      mySlots.sort((a, b) => a.slot_id - b.slot_id);
      handleSlots(mySlots, timerCallback);
    })
    .catch((er) => {
      console.log("Error", er);
    });
}

export async function runEthTimer(timerCallback) {
  $("body").removeClass("deedTime");
  await getEthTimeSlots()
    .then((querySnapshot) => {
      let mySlots = [];

      querySnapshot?.forEach((doc) => {
        mySlots.push(doc.data());
      });
      mySlots.sort((a, b) => a.slot_id - b.slot_id);
      handleSlots(mySlots, timerCallback);
    })
    .catch((er) => {
      console.log("Error", er);
    });
}

export async function handleSlots(mySlots, timerCallback) {
  // mySlots = [
  //   {
  //     start_date_time: "12/10/2022 19:00",
  //     end_date_time: "12/10/2022 19:15",
  //     slotName: "2",
  //     duration: 600000,
  //     isBreak: false,
  //     allowCategories: "LARGE,CONDO,GIGA",
  //     isPublic: false,
  //     start_time: 1671174837454,
  //     end_time: 1671174947454,
  //     msg: "Only Virtua VIPs and all Prestige members can mint large and giga plots in this slot.",
  //     slot_id: 1,
  //   },
  //   {
  //     slot_id: 2,
  //     allowCategories: null,
  //     end_time: 1671175037454,
  //     end_date_time: "12/10/2022 19:30",
  //     duration: 600000,
  //     start_date_time: "12/10/2022 19:15",
  //     msg: "Next Slot in:",
  //     isPublic: false,
  //     slotName: "BREAK",
  //     isBreak: true,
  //     start_time: 1671174947454,
  //   },
  //   {
  //     allowCategories: "LARGE,CONDO,GIGA",
  //     isBreak: false,
  //     duration: 600000,
  //     start_date_time: "12/10/2022 19:30",
  //     slot_id: 3,
  //     end_date_time: "12/10/2022 19:45",
  //     isPublic: false,
  //     msg: "Public.",
  //     slotName: "3",
  //     end_time: 1671175437454,
  //     start_time: 1671175037454,
  //   },
  // ];

  curTime = +new Date().getTime();
  let firstSlot = mySlots.at(0);

  if (curTime < firstSlot?.start_time) {
    let countDownTime = firstSlot.start_time - curTime;
    timerCallback.setTimerInstance(
      setPostDelay(countDownTime, "countDown", "", timerCallback)
    );
    return;
  }

  let isSlotStarted = false;
  for (let i = 0; i < mySlots.length; i++) {
    let data = mySlots[i];
    if (curTime >= data.start_time && curTime <= data.end_time) {
      // Get current slot
      let remainingTime = data.end_time - curTime;
      var msg = "";
      if (data.isBreak) {
        msg = data?.msg ? data?.msg : "";
        isSlotStarted = true;
        timerCallback.setTimerInstance(
          setPostDelay(remainingTime, msg, "Next Slot in", timerCallback)
        );
      } else if (!data.isPublic) {
        msg = data?.msg ? data?.msg : "";
        isSlotStarted = true;
        timerCallback.setTimerInstance(
          setPostDelay(
            remainingTime,
            msg,
            `for ${data.allowCategories} categories`,
            timerCallback
          )
        );
      } else if (data.isPublic) {
        msg = data?.msg ? data?.msg : "";
        isSlotStarted = true;
        timerCallback.setTimerInstance(
          setPostDelay(remainingTime, msg, `public`, timerCallback)
        );
      }
    }
  }

  let lastSlot = mySlots?.length > 0 ? mySlots.at(mySlots?.length - 1) : null;
  if (!isSlotStarted && lastSlot && curTime > lastSlot.end_time) {
    msg = `Minting has been closed.`;

    timerCallback.setTimerInstance(
      setPostDelay(0, msg, "closed", timerCallback)
    );
  } else if (!isSlotStarted) {
    msg = ``;

    timerCallback.setTimerInstance(
      setPostDelay(0, msg, "look_for_next_slot", timerCallback)
    );
  }
}

// Interval method for timer to handle slot end and start time
function setPostDelay(rem, msg, flag, timerCallback) {
  if (flag == "look_for_next_slot") {
    $("#slotMsg").hide();
    $("body").removeClass("deedTime");
    setTimeout(() => {
      timerCallback?.startNextSlot();
    }, 4000);
  } else if (flag == "closed") {
    var domElement = $("#slotMsg");
    $("#mainTimer").show();
    domElement.show();
    domElement.html(msg);
    $("body").addClass("deedTime");
    // $("#cardanoMainTimer").remove();
    // $("#cardanoLaunchTiming").remove();
    $("#slotTimer").removeClass("timer-visibility");
    $("#slotTimer").html(`<span className='dInlineBlock'></span>`);
    return null;
  } else {
    return setInterval(() => {
      rem -= 1000;
      var domElement = null;
      let messageElement = $("#slotMsg");
      domElement = messageElement;
      let mainElement = $("#mainTimer");
      let countDownElement = $("#ethCountdown");
      // let cardanoMainTimerElement = $("#cardanoMainTimer");
      // let cardanoCountDownElement = $("#cardanoLaunchTiming");
      let { days, hours, minutes, seconds } = convertMsToTime(rem);

      if (
        window.location.pathname == "/monsterzone" ||
        window.location.pathname == "/monsterzone/cardano"
      ) {
        // cardanoMainTimerElement.remove();
        // cardanoCountDownElement.remove();
        if (msg === "countDown") {
          if (rem <= 1) {
            countDownElement.remove();
            setTimeout(() => {
              timerCallback?.startNextSlot();
            }, 1000);
          } else {
            countDownElement.show();
            $("#countDown").html(
              `<span>${days}d</span> : <span>${hours}h</span> : <span>${minutes}m</span> : <span>${seconds}s</span>`
            );
          }
        } else {
          // if (seconds > -1) {
          countDownElement.remove();
          mainElement.show();
          domElement.show();
          domElement.html(`${msg}`);
          $("body").addClass("deedTime");
          if (flag !== "public") {
            $("#slotTimer").html(`<span className='dInlineBlock'>${padTo2Digits(
              hours
            )}h</span>:
           <span className="dInlineBlock pl--5">${padTo2Digits(
             minutes
           )}m</span>:
           <span className="dInlineBlock pl--5">${
             padTo2Digits(seconds) !== -1 ? padTo2Digits(seconds) : 0
           }s</span>`);
          } else {
            $("#slotTimer").removeClass("timer-visibility");
            $("#slotTimer").html(`<span className='dInlineBlock'></span>`);
          }
          // }
        }
      } else {
        domElement.hide();
        $("body").removeClass("deedTime");
      }

      if (rem <= 1) {
        domElement.hide();
        $("body").removeClass("deedTime");
        setTimeout(() => {
          timerCallback?.startNextSlot();
        }, 1000);
      }
    }, 1000);
  }
}

// Convert one digit to two digits for timer
function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}

// Convert milliseconds to day, hour, minute, seconds
function convertMsToTime(milliseconds) {
  let seconds = Math.floor(milliseconds / 1000);
  let minutes = Math.floor(seconds / 60);
  let hours = Math.floor(minutes / 60);
  let days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));
  seconds = seconds % 60;
  minutes = minutes % 60;
  hours = hours % 24;
  return { days, hours, minutes, seconds };
}
